import { Fragment } from 'react/jsx-runtime'
import {
	DiffSection,
	DiffSectionWrapper,
	FieldsDiffsSeparator
} from '@/features/ops-vetting/components/ops-vetting-merch-diffs'
import type { ExperienceDiffsMap } from '../types'

interface ExperienceVettingMerchCopyDiffsProps {
	experienceDiffsMap: ExperienceDiffsMap
}
export const ExperienceVettingMerchCopyDiffs = ({
	experienceDiffsMap
}: ExperienceVettingMerchCopyDiffsProps) => {
	return (
		<DiffSectionWrapper>
			<DiffSection
				hasDiff={experienceDiffsMap.improved_experience_title.hasDiff}
				size={experienceDiffsMap.improved_experience_title.fieldSize}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					experienceDiffsMap.improved_experience_description.hasDiff
				}
				hasUpperDiff={
					experienceDiffsMap.improved_experience_title.hasDiff
				}
			/>
			<DiffSection
				hasDiff={
					experienceDiffsMap.improved_experience_description.hasDiff
				}
				size={
					experienceDiffsMap.improved_experience_description.fieldSize
				}
			/>
			<FieldsDiffsSeparator fieldType='sub-section' />
			{experienceDiffsMap.activities.map((activity, index) => {
				const isLastItem =
					index === experienceDiffsMap.activities.length - 1
				return (
					<Fragment
						key={`activity-${activity[0].fieldSize}-${activity[1].fieldSize}`}
					>
						<DiffSection
							hasDiff={activity[0].hasDiff}
							size={activity[0].fieldSize}
						/>
						<FieldsDiffsSeparator
							fieldType='consecutive-sm'
							hasLowerDiff={activity[1].hasDiff}
							hasUpperDiff={activity[0].hasDiff}
						/>
						<DiffSection
							hasDiff={activity[1].hasDiff}
							size={activity[1].fieldSize}
						/>
						{!isLastItem && (
							<FieldsDiffsSeparator fieldType='sub-section' />
						)}
					</Fragment>
				)
			})}

			<FieldsDiffsSeparator fieldType='section' />

			<DiffSection
				hasDiff={
					experienceDiffsMap.improved_host_experience_title.hasDiff
				}
				size={
					experienceDiffsMap.improved_host_experience_title.fieldSize
				}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					experienceDiffsMap.improved_host_expertise_description
						.hasDiff
				}
				hasUpperDiff={
					experienceDiffsMap.improved_host_experience_title.hasDiff
				}
			/>
			<DiffSection
				hasDiff={
					experienceDiffsMap.improved_host_expertise_description
						.hasDiff
				}
				size={
					experienceDiffsMap.improved_host_expertise_description
						.fieldSize
				}
			/>
			<FieldsDiffsSeparator
				fieldType='consecutive-md'
				hasLowerDiff={
					experienceDiffsMap.improved_host_recognition_title
						?.hasDiff ?? false
				}
				hasUpperDiff={
					experienceDiffsMap.improved_host_expertise_description
						.hasDiff
				}
			/>
			<DiffSection
				hasDiff={
					experienceDiffsMap.improved_host_recognition_title
						?.hasDiff ?? false
				}
				size={'sm'}
			/>
		</DiffSectionWrapper>
	)
}
ExperienceVettingMerchCopyDiffs.displayName = 'ExperienceVettingMerchCopyDiffs'
